import FlowDiagramNode from '@/ecm/models/workflow/FlowDiagramNode'
import FlowDiagramTransition from '@/ecm/models/workflow/FlowDiagramTransition'
export default class FlowDiagram {
    constructor (dto) {
        this.flowName = '';
        this.nodes = [];
        this.connections = [];
        this.maxHeight = 0;

        if (dto) {
            this.flowName = dto.FlowName;
            let nodes = dto.States.map(x => new FlowDiagramNode(x));
            let connections = dto.Transitions.map(x => new FlowDiagramTransition(x, nodes));

            this.sort(nodes, connections, 1100);
        }
    }

    buildFrom(states, modalWidth) {
        let nodes = states.map((s) => {
            return {
                id: s.id,
                width: 200,
                x: 0,
                y: 10,
                level: 0,
                type: "operation",
                name: s.description,
                approvers: [{name: ' '}]
            };
        });

        let connections = states.flatMap((s) =>
            s.transitions.map((t) => {
                return {
                    id: s.id,
                    type: t.transitionType === "V" ? "pass" : "reject",
                    source: {id: s.id, position: 'bottom'},
                    destination: {id: t.stateTo, position: 'top'},
                };
            }));

        this.sort(nodes, connections, modalWidth);
    }

    sort(nodes, connections, modalWidth) {
        // While to code could be enhanced to prevent re-running loops, it is better for readability

        // pick one node as a root one
        nodes[0].moved = true;
        let levelCount = [{level: 0, nodes: [nodes[0]]}]

        // Sort vertically
        nodes.forEach((node) => {
            let connectionForThisNode = connections.filter((conn) => conn.id == node.id);

            if (connectionForThisNode.length == 1) {
                let selectedNode = nodes.find((childNode) => childNode.id == connectionForThisNode[0].destination.id);

                if (!selectedNode.moved) {
                    selectedNode.level = node.level + 1;
                    selectedNode.y += selectedNode.level * 90;

                    selectedNode.moved = true;
                    levelCount.push({level: selectedNode.level, nodes: [selectedNode]});
                }

                // if we jump at least two spaces
                if (node.nodeCount > (selectedNode.nodeCount + 1))  {
                    let connection = connections.find(t => t.id == connectionForThisNode[0].id);
                    connection.source.position = "left";
                    connection.destination.position = "left";
                }

            } else if (connectionForThisNode.length > 1) {
                connectionForThisNode.forEach((shallowNode, index) => {
                    let selectedNode = nodes.find((childNode) => childNode.id == connectionForThisNode[index].destination.id);

                    if (!selectedNode.moved) {
                        selectedNode.level = node.level + 1;
                        selectedNode.y += selectedNode.level * 90;

                        selectedNode.moved = true;

                        let thisLevel = levelCount.find((element) => element.level == selectedNode.level);
                        if (thisLevel === undefined)
                            levelCount.push({level: selectedNode.level, nodes: [selectedNode]});
                        else
                            thisLevel.nodes.push(selectedNode);
                    }
                });
            }
        });

        // Sort horizontally
        levelCount.forEach((level) => {
            let nodeCount = level.nodes.length;

            let splits = modalWidth / nodeCount;

            level.nodes.forEach((node, index) => {
                node.x = (splits * index) + ((splits / 2) - 60); // 60 = Half node
            });
        });

        // Modify top bottom to lateral connections
        nodes.forEach((node) => {
            let connectionForThisNode = connections.filter((conn) => conn.id == node.id);

            connectionForThisNode.forEach((shallowNode, index) => {
                let selectedNode = nodes.find((childNode) => childNode.id == connectionForThisNode[index].destination.id);

                // if we jump two spaces
                let levelDifference = (node.level - selectedNode.level);

                if (Math.abs(levelDifference) > 1 ||
                    levelDifference === 1 ||
                    levelDifference === 0) {
                    let connection = connections.find(t => t.id == connectionForThisNode[index].id && t.destination.id == selectedNode.id);

                    if (node.x > selectedNode.x) {
                        connection.source.position = "left";
                        connection.destination.position = "right";
                    } else if (node.x < selectedNode.x) {
                        connection.source.position = "right";
                        connection.destination.position = "left";
                    } else if (node.x == selectedNode.x) {
                        connection.source.position = "right";
                        connection.destination.position = "right";
                    }
                }
            });
        });

        // Node without connections
        let disconnectedNodes = 0;
        nodes.forEach((node) => {
            let connectionForThisNode = connections.filter((conn) => conn.source.id == node.id || conn.destination.id == node.id);

            if (connectionForThisNode.length === 0) {
                node.x = 0;
                node.y = disconnectedNodes * 60;

                disconnectedNodes++;
            }
        });

        let highestNode = nodes.reduce((max, current) => {
            return max.y > current.y ? max : current;
        }, 0);

        this.maxHeight = highestNode.y + 80;
        this.nodes = nodes;
        this.connections = connections;
    }
}